module.exports = __webpack_public_path__ + "img/WAO-logo.ca04af39.png";